import type { RemovalRequestsListParams } from "../../admin-api/removals";

export const athleteQueryKeys = {
	athletes: {
		all: ["athletes"] as const,
		claims: ["athletes", "claims"] as const,
		detail: (id: string) => ["athletes", "detail", id] as const,
		duplicates: ["athletes", "duplicates"] as const,
		list: (params: object) => ["athletes", "list", params] as const,
		removalList: (params: RemovalRequestsListParams) => ["athletes", "removals", params] as const,
	},
	scraper: {
		runs: ["scraper", "runs"] as const,
		sources: ["scraper", "sources"] as const,
		syncs: ["scraper", "syncs"] as const,
	},
} as const;
